<template>
  <div>
    <!-- 大图预览 -->
    <el-dialog
      :title="titleH"
      :visible.sync="bigImgsShow"
      :width="widths"
      center
      :close-on-click-modal="false"
    >
      <div class="" style="display: flex">
        <div v-for="(item, index) in srcList" :key="index">
          <el-image
            style="width: 180px; height: 180px; margin: 10px"
            :src="item"
            :preview-src-list="srcList"
          >
          </el-image>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" size="mini" @click="closeDialog"
          >关闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    titleH: {
      typeof: String,
      default: "",
    },
    widths: {
      typeof: String,
      default: "50%",
    },
    bigImgsShow: {
      typeof: Boolean,
      default: false,
    },
    srcList: {
      typeof: Array,
      default: [],
    },
  },
  data() {
    return {};
  },
  watch: {},
  created() {},
  mounted() {},
  activated() {},
  destroyed() {},
  methods: {
    closeDialog() {
      //   this.bigImgsShow = false;
      this.$emit("closeDialog", false);
    },
  },
};
</script>
<style scoped lang='less'></style>